/* eslint-disable @typescript-eslint/no-explicit-any */
// config/nyandarua.config.ts
import {services as nyandaruaServices} from './icrms/services';

export const nyandaruaConfig = {
  name: 'NyandaruaPay - Customer Portal',
  themeMode: 'light', // default: "light" | can toggle dynamically
  theme: {
    light: {
      primary: '#60AC49',
      secondary: '#00ae4d',
      accent: '#AD0035',
      background: '#ffffff',
      foreground: '#171717',
      'surface-header': '#FFFCEE',
    },
    dark: {
      primary: '#00ae4d',
      secondary: '#00ae4d',
      accent: '#AD0035',
      background: '#0a0a0a',
      foreground: '#ededed',
      'surface-header': '#FFFCEE',
    },
  },

  // Assets (served from /dev/nyandarua/public)
  logo: `/nyandarua/logo.svg`,
  favicon: '/nyandarua/favicon-64.png',
  faviconSvg: '/nyandarua/favicon.svg',
  favicon64: '/nyandarua/favicon-64.png',
  favicon128: '/nyandarua/favicon-128.png',

  // Hero section
  heroSection: {
    title: (
      <>
        <span className="font-extrabold">NyandaruaPay</span> –{' '}
        <span className="">
          fast & <br /> secure
        </span>{' '}
        county payments!
      </>
    ),
    description: (
      <>
        Experience hassle-free payments for county <br /> services with just a
        few clicks.
      </>
    ),
    image: `/nyandarua/images/herosection.png`,
  },

  // Services section
  servicesSection: {
    title: (
      <>
        <strong>Nyandarua County</strong> Government Services
      </>
    ),
    description: (
      <>
        The Nyandarua County Portal enables you to access and
        make payments for a wide range of services from the County Government of
        Nyandarua. Please select a service below to proceed.
      </>
    ),
    services: nyandaruaServices, // 👈 loaded from config/nyandarua/services.ts
  },

  contact: {
    hq: {
      coords: [-0.2705655858595626, 36.3747517369362], // Nyandarua HQ
      label: 'Nyandarua County Headquarters – Ol Kalou',
    },
    details: [
      {
        id: 'postal',
        label: 'Postal Address',
        value: (
          <>
            P.O Box 701- 20303
            <br />
            OlKalou
          </>
        ),
      },
      {
        id: 'email',
        label: 'Email',
        value: <>info@nyandarua.go.ke</>,
      },
      {
        id: 'tel',
        label: 'Telephone',
        value: <>0792735720, 0792735736</>,
      },
      {
        id: 'ambulance',
        label: 'Ambulance Service',
        value: <>0735 018 018</>,
      },
      {
        id: 'fire',
        label: 'Fire or Any Other Disaster',
        value: <>0735 018 018</>,
      },
      {
        id: 'security',
        label: 'Security Matters',
        value: <>0735 018 018</>,
      },
    ],
  },

  // Footer section
  footer: {
    description:
      'The Nyandarua County Service Portal provides easy access to a wide range of services, from business licenses to essential services. Pay securely and manage all your county-related tasks from one platform.',
    copyright: '© 2025 County Government of Nyandarua. All rights reserved.',
    links: [
      { title: 'Home', url: '/' },
      { title: 'Services', url: '/#services' },
      { title: 'Support', url: '/support/' },
    ],
  },

  // API base URL
  getApiBaseUrl: () => {
    if (typeof window !== 'undefined') {
      return (window as any).__RUNTIME_CONFIG__?.NEXT_PUBLIC_BASE_API;
    }
    return process.env.NEXT_PUBLIC_BASE_API;
  },
};
